import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from './utils';
function BtwSkeleton(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (_jsx("div", Object.assign({ className: cn('isolate', 'relative', 'rounded-md', 'overflow-hidden', 'bg-gray-200/40', 'before:absolute', 'before:inset-0', 'before:-translate-x-full', 'before:animate-[shimmer_1.25s_infinite]', 'before:bg-gradient-to-r', 'before:from-transparent', 'before:via-gray-400/10', 'before:to-transparent', className) }, rest)));
}
export { BtwSkeleton };
